export default __webpack_public_path__ + "static/media/bag.59818bc7.png";